// Lives in a .ts file so Fast Refresh isn't invalidated by mixed exports in the .tsx Provider.
import { createContext } from "react";
import type { UseAuthReturn } from "@/types/auth";

export const AuthContext = createContext<UseAuthReturn | null>(null);
